<template>
  <NodeEditor
    :node="value"
    @editFinish="$_savingOptionsMixin_onEditFinish"
    @delete="$_savingOptionsMixin_onDelete"
  >
    <EditChartHeader :value="value" />
    <div class="horizontal-bar-chart-container">
      <svg ref="chart" class="pigeondoc-chart horizontal-bar-chart"></svg>
    </div>
  </NodeEditor>
</template>

<script>
import EditChartHeader from '../ChartHeader/EditChartHeader.vue';
import NodeEditor from '../NodeEditor/NodeEditor.vue';

import horizontalChartMixin from './horizontalChartMixin.js';
import savingOptionsMixin from '../NodeEditor/Mixins/savingOptionsMixin.js';

export default {
  name: 'HorizontalBarChart',
  mixins: [horizontalChartMixin, savingOptionsMixin],
  components: {
    EditChartHeader,
    NodeEditor,
  },
};
</script>
